/*eslint quote-props: off*/
const tr = {
  subscription: {
    attributes: {
      id: 'ID',
      google_month_product_id: 'ID na Google Store',
      apple_month_product_id: 'ID na Apple Store',
      is_active:'Ativo',
      currency:'Moeda',
      month_price: 'Preço Mensal',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
      type: 'Tipo',
      coin: 'Moeda',
      name: 'Título',
      lang: 'Linguagem',
    },
    defSingular: 'Assinatura',
    defPlural: 'Assinaturas',
    extras:{
      new: 'Criar assinatura',
      edit:   'Editar assinatura',
      show:   'Exibir assinatura',
    }
  },
};

export default tr;
